import request from '../utils/request';

/**
 * 发送聊天消息（流式返回）
 * @param {Array} messages - 消息列表 [{ role: 'user'|'assistant', content: '...' }]
 * @returns {Promise}
 */
export function sendChatMessage(messages) {
    return request({
        url: '/ai/chat',
        method: 'post',
        data: { messages }
    });
}
